import { Badge } from "@/components/ui/badge";
import { getPublicationStatusLabel, type PublicationStatus } from "@/lib/catalog/catalog-workflow";
import { cn } from "@/lib/utils";

interface PublicationStatusBadgeProps {
  status: PublicationStatus;
}

const toneClasses: Record<PublicationStatus, string> = {
  DRAFT: "bg-slate-100 text-slate-700",
  PENDING_REVIEW: "bg-amber-100 text-amber-800",
  RETURNED: "bg-orange-100 text-orange-800",
  REJECTED: "bg-red-100 text-red-800",
  PUBLISHED: "bg-green-100 text-green-800",
};

export function PublicationStatusBadge({ status }: PublicationStatusBadgeProps) {
  return (
    <Badge variant="outline" className={cn("border-transparent", toneClasses[status])}>
      {getPublicationStatusLabel(status)}
    </Badge>
  );
}
